import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { StateType } from '../../reducers';
import { getUserIdSelector } from '../../reducers/AuthenticationReducer/AuthenticationSelector';
import { logErrorService } from '../../shared/services';

import './ErrorBoundary.scss';
import { ErrorMessage } from './ErrorMessage';

interface ErrorBoundaryState {
  hasError: boolean;
}

interface ErrorBoundaryProps {
  children: React.ReactNode;
  showUI?: boolean;
  isNotFullScreen?: boolean;
  hideElement?: boolean;
  isModal?: any;
}

interface ErrorBoundaryStateProps {
  userId: string;
}

interface ErrorBoundaryStateDispatchers {}

type ErrorBoundaryPropsGeneric = ErrorBoundaryProps & ErrorBoundaryStateDispatchers & ErrorBoundaryStateProps & RouteComponentProps<any>;

class ErrorBoundary extends React.Component<ErrorBoundaryPropsGeneric, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryPropsGeneric) {
    super(props);
    this.state = { hasError: false };
    const history = this.props.history;
    history.listen(() => {
      if (this.state.hasError) {
        this.setState({
          hasError: false,
        });
      }
    });
  }

  componentDidUpdate(prevProps: ErrorBoundaryPropsGeneric) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({
        hasError: false,
      });
    }
  }

  componentDidCatch(error: any, info: any) {
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    logErrorService(error, info);
  }

  removeModal() {
    if (this.props.isModal) {
      const modals: any = document.querySelectorAll('.modal');
      modals.forEach((element: any) => {
        element.parentNode.removeChild(element);
      });
    }
  }

  render() {
    if (this.state.hasError && this.props.showUI) {
      this.removeModal();

      return <ErrorMessage isNotFullScreen={this.props.isNotFullScreen ? true : false} userId={this.props.userId} />;
    } else if (this.state.hasError && !this.props.showUI && this.props.hideElement) {
      this.removeModal();

      return null;
    }

    return this.props.children;
  }
}

const mapStateToProps = (state: StateType): ErrorBoundaryStateProps => ({
  // @ts-expect-error connect own-props collapse under @types/react@19
  userId: getUserIdSelector(state),
});

export default withRouter(connect<ErrorBoundaryStateProps, {}, ErrorBoundaryProps, StateType>(mapStateToProps, {})(ErrorBoundary));
